module.exports = __webpack_public_path__ + "static/media/uit3.2e731a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uit3.jpg
// module id = 5808
// module chunks = 0